import React from 'react'
import UploadTemplate from './UploadTemplate/UploadTemplate.container'

const TemplateCreate: React.FC = () => {
  return <UploadTemplate />
}

export default TemplateCreate
